import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';
import { ReportConfig } from './api.report.data';

export class APIGetReportConfigManager extends APIBaseManager<void, void, void, ReportConfig> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_GetReportConfig';
        this._apiMethod = 'GET';
    }

    protected getRequestURL(pathParameters: void, queryParameters: void): string {
        return super.getRequestURL() + 'accounts/weeklyReportSettings';
    }
}